import { redirect } from 'react-router-dom';
import { captureException } from '@sentry/react';
import { useApplicationStore } from '@data';
import { refetchAndSetPatientProfile } from './utils';
import { fetchUpcomingVisits } from '@api';

export default async function idVerificationLoader(): Promise<Response | null> {
  const { patient } = useApplicationStore.getState();

  if (!patient.patientProfile) {
    try {
      await refetchAndSetPatientProfile();
    } catch {
      return redirect('/services');
    }
  }

  if (!patient.upcomingVisits) {
    try {
      const upcomingVisits = await fetchUpcomingVisits();

      patient.setUpcomingVisits(upcomingVisits);
    } catch (error) {
      captureException(error);
    }
  }
  const promise = new Promise((resolve) => {
    try {
      const script = document.createElement('script');

      script.src = 'https://static.vouched.id/plugin/releases/v3.39.2/index.js';
      script.async = true;
      document.body.appendChild(script);
      script.addEventListener('load', function () {
        resolve(true);
      });
      script.onerror = () => {
        return redirect('/booking-confirmation');
      };
    } catch (error) {
      captureException(error);
      return redirect('/booking-confirmation');
    }
  });
  await promise;
  return null;
}
